import { supabase } from './mockData';

type ProfileWithClinic = {
  clinic_id: string;
  full_name: string | null;
  clinics: { name: string } | null;
};

/**
 * Supabase Auth kullanıcısı için profiles + klinik adı.
 * Çok klinik kurulumunda her kullanıcının profiles satırı ve clinic_id olmalıdır.
 */
export async function loadUserProfile(userId: string): Promise<{
  clinicId: string;
  clinicName: string;
  displayName: string;
} | null> {
  const { data, error } = await supabase
    .from('profiles')
    .select('clinic_id, full_name, clinics ( name )')
    .eq('id', userId)
    .maybeSingle();

  if (error) {
    console.warn('Profil okunamadı:', error.message);
    return null;
  }

  const row = data as unknown as ProfileWithClinic | null;
  if (!row?.clinic_id) {
    return null;
  }

  return {
    clinicId: row.clinic_id,
    clinicName: row.clinics?.name ?? '',
    displayName: row.full_name?.trim() || '',
  };
}
